import React, { useState } from 'react';
import { Button, DialogContent, DialogActions, TextField } from '@mui/material';
import { Dialog } from '@jbrowse/core/ui';
export const ExternalTokenEntryForm = ({ internetAccountId, handleClose, }) => {
    const [token, setToken] = useState('');
    return (React.createElement(Dialog, { open: true, maxWidth: "xl", "data-testid": "externalToken-form", title: `Enter token for ${internetAccountId}` },
        React.createElement(DialogContent, { style: { display: 'flex', flexDirection: 'column' } },
            React.createElement(TextField, { required: true, label: "Enter Token", variant: "outlined", inputProps: { 'data-testid': 'entry-externalToken' }, onChange: event => setToken(event.target.value), margin: "dense" })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: "contained", color: "primary", type: "submit", disabled: !token, onClick: () => {
                    if (token) {
                        handleClose(token);
                    }
                } }, "Add"),
            React.createElement(Button, { variant: "contained", color: "secondary", onClick: () => handleClose() }, "Cancel"))));
};
